import { useTranslation } from 'react-i18next';
import { CircularProgress } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import { color } from '@/colors';
import { FlexCenHorVer } from '@/UI/styles';
import { ButtonContained } from '@/UI/Buttons/AppButton';
import { I18N_KEYS } from '@/language/keys';
import { FolderCardDisplay } from '../components/FolderCardDisplay';
import { DashboardCard } from '../DashboardCard';
import type { ArchiveItem } from './archive.types';
import type { FolderWorkflowData } from '../utils/listView.utils';

interface ArchiveFolderCardProps {
  item: ArchiveItem;
  onRestore: (id: string, type: 'workflow' | 'folder') => void;
  isRestoring?: boolean;
  folderFileCount: number;
  folderData: FolderWorkflowData[string] | undefined;
}

const ArchiveFolderCard = ({ item, onRestore, isRestoring, folderFileCount, folderData }: ArchiveFolderCardProps) => {
  const { t } = useTranslation();

  return (
    <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
      <DashboardCard>
        <FolderCardDisplay
          id={item.id}
          name={item.name}
          posters={folderData?.posters ?? []}
          totalFiles={folderData?.count ?? 0}
          fileCount={folderFileCount}
          forceShowOverlay={isRestoring}
          hoverOverlay={
            <FlexCenHorVer
              sx={{
                position: 'absolute',
                inset: 0,
                backgroundColor: color.Black40_T,
              }}
            >
              <ButtonContained
                size="small"
                mode="filled-light-secondary"
                endIcon={isRestoring && <CircularProgress size={14} sx={{ color: 'inherit' }} />}
                onClick={() => onRestore(item.id, 'folder')}
                sx={{ pointerEvents: isRestoring ? 'none' : 'auto' }}
              >
                {t(I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.RESTORE)}
              </ButtonContained>
            </FlexCenHorVer>
          }
        />
      </DashboardCard>
    </Grid2>
  );
};

export default ArchiveFolderCard;
